import { useEffect, useState } from 'react';
import { CheckCircle2, Circle, Loader2 } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';

/* =====================================================================
   Tu empresa en marcha · ERP-OPERATIVO EC5
   =====================================================================
   Los pasos de la casa (dónde guardas, quién trabaja, qué vendes) más
   los comerciales (existencias, cliente, venta, perfil). Cada paso dice
   si ya está y a dónde ir para hacerlo. Nada se marca a mano: se mide.
   ===================================================================== */
export default function TuEmpresaEnMarcha({ irA }) {
  const [e, setE] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let vivo = true;
    api.get('/comercial/arranque').then((d) => { if (vivo) setE(d); }).catch((err) => { if (vivo) setError(err.message); });
    return () => { vivo = false; };
  }, []);
  if (error) return <p className="p-4 text-sm text-red-700">{error}</p>;
  if (!e) {
    return (
      <p className="flex items-center gap-2 p-4 text-sm text-gray-500">
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Midiendo cómo va tu empresa…
      </p>
    );
  }
  const pct = e.total ? Math.round((e.hechos / e.total) * 100) : 0;
  return (
    <div className="flex max-w-3xl flex-col gap-5 p-4">
      <header>
        <h1 className="text-xl font-semibold text-gray-900">Primer arranque</h1>
        <p className="text-gray-600">Lo que hace falta para operar hoy, medido sobre tus datos.</p>
        <Ayuda id="comercial.arranque.pantalla" />
      </header>
      <div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-gray-100">
          <div className={`h-3 ${e.lista ? 'bg-green-500' : 'bg-[var(--color-marca)]'}`} style={{ width: `${pct}%` }} />
        </div>
        <p className="mt-1 text-sm text-gray-700">{e.mensaje}</p>
      </div>
      <ol className="flex flex-col gap-2">
        {e.pasos.map((p) => (
          <li key={p.clave} className="flex items-start gap-3 rounded-xl border border-gray-200 p-3">
            {p.hecho
              ? <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-green-600" aria-hidden="true" />
              : <Circle className="mt-0.5 h-5 w-5 shrink-0 text-gray-300" aria-hidden="true" />}
            <div className="flex-1">
              <p className={`font-medium ${p.hecho ? 'text-gray-500 line-through' : 'text-gray-900'}`}>{p.titulo}</p>
              <p className="text-sm text-gray-600">{p.como}</p>
            </div>
            {!p.hecho && p.modulo && irA && (
              <button type="button" onClick={() => irA(p.modulo)}
                      className="rounded-xl bg-[var(--color-marca)] px-3 py-1.5 text-sm font-semibold text-white">Ir</button>
            )}
          </li>
        ))}
      </ol>
      <p className="text-xs text-gray-500">Perfil de operación: {e.perfil}. Un paso se tacha solo cuando el dato existe.</p>
    </div>
  );
}
